import {auth} from '../../Auth'

export function organizationFilter (query) {
  query.filters.push({match: {'organization.id': auth.sunkaizenUser.organization.id}})
}